/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetPrimaryCartQueryVariables = Exact<{
	filter?: Types.Primary_Artworks_Filter | null | undefined;
	genericFilter?: Types.Primary_Generic_Artwork_Filter | null | undefined;
}>;

export type GetPrimaryCartQuery = {
	Primary_Generic_Artwork: Array<{
		id: string;
		additional_info: string | null;
		dimensions: string;
		title: string;
		artists: Array<{
			Artists_id: { name: string | null; surname: string | null } | null;
		} | null> | null;
		product: {
			id: string;
			currency: string;
			sku: string;
			price: number;
		} | null;
		collection: {
			name: string | null;
			code: string | null;
			drop_page: {
				drop_config: Array<{
					id: string;
					hide_prices: boolean | null;
				} | null> | null;
			} | null;
		} | null;
	}>;
	Primary_Artworks: Array<{
		id: string;
		artwork_dimensions: string | null;
		artwork_title: string | null;
		artwork_code: string | null;
		artwork_width_cm: number | null;
		artwork_height_cm: number | null;
		artists: Array<{
			Artists_id: { name: string | null } | null;
		} | null> | null;
		primary_collection: {
			id: string;
			code: string | null;
			name: string | null;
			drop_page: {
				drop_config: Array<{
					id: string;
					hide_prices: boolean | null;
				} | null> | null;
			} | null;
		} | null;
		product: {
			id: string;
			currency: string;
			price: number;
			sku: string;
		} | null;
		artwork_featured_image: {
			filename_disk: string | null;
			width: number | null;
			height: number | null;
		} | null;
	}>;
};

export const GetPrimaryCartDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'getPrimaryCart' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'filter' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'Primary_Artworks_filter' },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'genericFilter' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'Primary_Generic_Artwork_filter' },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Primary_Generic_Artwork' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'genericFilter' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'additional_info' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artists' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'Artists_id' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'name' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'surname' },
														},
													],
												},
											},
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'dimensions' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'product' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'currency' },
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'sku' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'price' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'collection' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'code' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'drop_page' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'drop_config' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'id' },
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'hide_prices',
																		},
																	},
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Primary_Artworks' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'filter' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artwork_dimensions' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artwork_title' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artwork_code' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artwork_width_cm' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artwork_height_cm' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artists' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'Artists_id' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'name' },
														},
													],
												},
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'primary_collection' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'code' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'drop_page' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'drop_config' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'id' },
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'hide_prices',
																		},
																	},
																],
															},
														},
													],
												},
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'product' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'currency' },
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'price' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'sku' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artwork_featured_image' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ImageWithDimensions' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageWithDimensions' },
			typeCondition: {
				kind: 'NamedType',
				name: { kind: 'Name', value: 'directus_files' },
			},
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'filename_disk' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'height' } },
				],
			},
		},
	],
} as unknown as DocumentNode<GetPrimaryCartQuery, GetPrimaryCartQueryVariables>;
